import * as moment from 'moment';

export class Patient {
    concat_address: string = "";
    id: number;
    name: string;
    mobile: string;
    uhid: string;
    dob: Date;
    _age: string;
    gender: string;
    email: string;
    _addresses: any;
    age: number;
    age_months: number;
    age_days: number;
    salutation: string;



    constructor(values: Object = {}) {
        Object.assign(this, values);
        
        if (this.dob) {
            let age = '';
                let dob = new Date(this.dob);
                let diff = this.dateDiff(new Date(), dob);
                if(diff.years) {
                    age += diff.years;
                    age += ' y ';    
                }
                if (diff.months) {
                    age += diff.months;
                    age += ' m ';
    
                }
                if (diff.days) {
                    age += diff.days;
                    age += ' d';
                }
    
                this._age = age;

        } else {
            let age = '';
            if (values['age']) {
                age += values['age'];
                age += ' y ';
            }

            if (values['age_months']) {
                age += values['age_months'];
                age += ' m ';

            }


            if (values['age_days']) {
                age += values['age_days'];
                age += ' d';
            }

            this._age = age;
        }

        if (this._addresses && this._addresses.length) {
            if (this._addresses[0].address) {
                this.concat_address += this._addresses[0].address + ', ';
            }
            if (this._addresses[0].locality) {
                this.concat_address += this._addresses[0].locality + ', ';
            }
            if (this._addresses[0].pin_code) {
                this.concat_address += this._addresses[0].pin_code + ', ';
            }
            if (this._addresses[0].city) {
                this.concat_address += this._addresses[0].city + ', ';
            }
            if (this._addresses[0].state) {
                this.concat_address += this._addresses[0].state + ', ';
            }
            if (this._addresses[0].country) {
                this.concat_address += this._addresses[0].country;
            }
        }

        if (this.concat_address.charAt(this.concat_address.length - 2) == ',') {
            this.concat_address = this.concat_address.slice(0, -2);
        }

    }
    

    dateDiff(dt1, dt2) {
        /*
         * setup 'empty' return object
         */
        var ret = { days: 0, months: 0, years: 0 };
        /*
         * If the dates are equal, return the 'empty' object
         */
        if (dt1 == dt2) return ret;
    
        /*
         * ensure dt2 > dt1
         */
        if (dt1 > dt2) {
          var dtmp = dt2;
          dt2 = dt1;
          dt1 = dtmp;
        }
    
        /*
         * First get the number of full years
         */
    
        var year1 = moment(dt1).year();
        var year2 = moment(dt2).year();
    
        var month1 = moment(dt1).month();
        var month2 = moment(dt2).month();
    
        var day1 = moment(dt1).date();
        var day2 = moment(dt2).date();
    
        /*
         * Set initial values bearing in mind the months or days may be negative
         */
    
        ret['days'] = day2 - day1;
        ret['months'] = month2 - month1;
        ret['years'] = year2 - year1;
    
        /*
         * Now we deal with the negatives
         */
    
        /*
         * First if the day difference is negative
         * eg dt2 = 13 oct, dt1 = 25 sept
         */
        if (ret['days'] < 0) {
          /*
           * Use temporary dates to get the number of days remaining in the month
           */
          var dtmp1 = new Date(dt1.getFullYear(), dt1.getMonth() + 1, 1, 0, 0, -1);
    
          var numDays = dtmp1.getDate();
    
          ret['months'] -= 1;
          ret['days'] += numDays;
    
        }
    
        /*
         * Now if the month difference is negative
         */
        if (ret['months'] < 0) {
          ret['months'] += 12;
          ret['years'] -= 1;
        }
    
        return ret;
      }
}

